import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface JFrogSettingsFormValues {
  repository_name: string;
  repository_url: string;
  username: string;
  api_token: string;
  repository_key: string;
  tls_cert?: string;
}

export const jfrogSettingsDefaultValues: JFrogSettingsFormValues = {
  repository_name: '',
  repository_url: '',
  username: '',
  api_token: '',
  repository_key: '',
  tls_cert: ''
};

export const jfrogSettingsSchema = yup.object({
  repository_name: yup
    .string()
    .required('Repository Name is required')
    .min(3, 'Must be 3-64 characters')
    .max(64, 'Must be 3-64 characters'),
  repository_url: yup
    .string()
    .required('Repository URL is required')
    .url('Must be a valid URL')
    .matches(/^https?:\/\//, 'URL must start with http:// or https://'),
  username: yup
    .string()
    .required('Username is required')
    .min(3, 'Must be 3-64 characters')
    .max(64, 'Must be 3-64 characters'),
  api_token: yup
    .string()
    .required('API Token is required')
    .min(8, 'Must be between 8-128 characters')
    .max(128, 'Must be between 8-128 characters'),
  repository_key: yup
    .string()
    .required('Repository Key is required')
    .min(1, 'Repository Key is required'),
  tls_cert: yup
    .string()
    .optional()
    .test('certificate-format', 'Invalid certificate format', function(value) {
      if (!value || value.trim() === '') return true; // Optional field
      return value.includes('-----BEGIN CERTIFICATE-----') && value.includes('-----END CERTIFICATE-----');
    })
});

export function useJFrogSettingsForm(initialValues?: any) {
  return useForm({
    values: initialValues || jfrogSettingsDefaultValues,
    mode: 'onSubmit',
    resolver: yupResolver(jfrogSettingsSchema),
    defaultValues: { ...jfrogSettingsDefaultValues, ...initialValues },
  });
}
